import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/Navbar/NavBar";
import heroImg from "../images/web-dev.svg";
import { Helmet } from "react-helmet-async";

const Hero = () => {
  return (
    <>
      {/* <Helmet>
        <title>TeqnoDux | Global Leaders in Software Development</title>
        <meta name="author" content="TeqnoDux" />
        <meta property="og:site_name" content="TeqnoDux" />
        <meta
          name="description"
          content="We are global leaders in software development craftsmanship, delivering high-quality software solutions tailored to your needs."
        />
        <meta
          property="og:title"
          content="TeqnoDux | Global Leaders in Software Development"
        />

        <meta
          property="og:description"
          content="We are global leaders in software development craftsmanship, delivering high-quality software solutions tailored to your needs."
        />
        <meta property="og:image" content={heroImg} />
        <meta property="og:type" content="website" />
      </Helmet> */}
      <div className="hero" id="home">
        <div>
          <NavBar />
        </div>

        <div
          className="container mx-auto px-4 mt-8 lg:mt-4 p-2 md:p-12 h-full"
          data-aos="zoom-in"
        >
          <div
            id="home"
            className="flex flex-col-reverse lg:flex-row items-center py-8 justify-between text-center lg:text-left h-screen lg:h-auto"
          >
            {/* Text Section */}
            <div
              className="lg:w-1/2 flex flex-col justify-start items-center lg:items-start flex-1"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <h1 className="mb-5 text-2xl sm:text-3xl  font-bold text-[#377c7d]">
                Under Promise. Over Deliver
              </h1>
              <p className="text-base sm:text-md md:text-lg font-semibold tracking-tight mb-5 text-gray-500">
                We are global leaders in software development craftsmanship —
                turning ambitious ideas into high-performing digital
                experiences.
              </p>
              <div className="mb-4 space-y-4 md:space-y-0 md:space-x-2 flex flex-col md:flex-row">
                <Link
                  to="/contact"
                  className="text-white bg-[#377c7d] hover:bg-[#2b6262] inline-flex items-center justify-center w-full px-6 py-3 text-lg shadow-xl rounded-2xl sm:w-auto"
                >
                  Learn more
                  <svg
                    className="w-4 h-4 ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>

            {/* Image Section */}
            <div
              className="flex justify-center lg:justify-end w-full lg:w-1/2 mb-4 lg:mb-0 flex-1"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <img
                alt="Hero"
                className="rounded-t float-right duration-1000 w-3/4 md:w-full"
                src={heroImg}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
